// @flow
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontNormal } from "@fdr/static-ui/Typography";
import { buildText } from "../../_atoms/Text";

export const Text = styled(buildText())`
  margin-left: 8px;
`;

const commonButtonStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  border-radius: 4px;
  padding: 0 20px;
  font-size: 14px;
  font-family: ${fontNormal};
  text-decoration: none;
  outline: none;
  width: 100%;
`;

const getButtonStyles = (type) =>
  type === "promo"
    ? css`
        ${commonButtonStyles}
        background: ${buildColor("yellow")};
        color: ${buildColor("grey", "D4")};

        &:active {
          background: ${buildColor("yellow", "D2")};
        }
      `
    : css`
        ${commonButtonStyles}
        background: linear-gradient(
          180deg,
          ${buildColor("green", "L1")} 0%,
          ${buildColor("green", "D1")} 100%
        );
        color: ${buildColor("white")};

        &:active {
          background: ${buildColor("green", "700")};
        }
      `;

export const PromoLink = styled(Link)`
  ${({ type }) => getButtonStyles(type)}
`;

export const PromoLinkExternal = styled.a.attrs((props) => ({
  href: props.to
}))`
  ${({ type }) => getButtonStyles(type)}
`;
